// extracted by mini-css-extract-plugin
export default {"svgColor":"Icons_svgColor__AhIDi","hoverable":"Icons_hoverable__fGbP1","hovered":"Icons_hovered__GJcDB","active":"Icons_active__FCbuD"};